module.exports = __webpack_public_path__ + "static/transferenceFund-aeef0d5609b40abdb49fe661b648f421.png";